import { render } from "./the-ebooks.vue?vue&type=template&id=75ef534c&scoped=true&ts=true"
import script from "./the-ebooks.vue?vue&type=script&lang=ts"
export * from "./the-ebooks.vue?vue&type=script&lang=ts"

import "./the-ebooks.vue?vue&type=style&index=0&id=75ef534c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75ef534c"]])

export default __exports__